import { formatCurrency } from "@/utils/format-currency";
import { formatLabel } from "@/utils/format-label";
import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import { InvoiceActionsPopover } from "./invoice-actions-popover";

export const InvoiceColumns = [
  {
    accessorKey: "invoiceNumber",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Invoice No</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.invoiceNumber ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "merchantName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Merchant</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.merchantName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "buyerName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Customer Name</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.buyerName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "totalAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Total Amount</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatCurrency(row.original.totalAmount) ?? "0"}
      </div>
    ),
  },
  {
    accessorKey: "invoiceStatus",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const status = row.original.invoiceStatus;

      const getStatusColor = () => {
        switch (status) {
          case "SETTLED":
            return { bg: "#ecfdf5", color: "#065f46" };
          case "UNSETTLED":
          default:
            return { bg: "#fffbeb", color: "#92400e" };
        }
      };

      const { bg, color } = getStatusColor();

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {formatLabel(status) ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "invoiceDate",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date</div>,
    cell: ({ row }) => {
      const date = row.original.invoiceDate;

      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      const parsed = parseISO(date);

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actions</div>,
    cell: ({ row }) => <InvoiceActionsPopover invoice={row.original} />,
  },
];
